import { ONE, ZERO } from '@/constants/common';
import { MiriamType, Statistics } from '@/types/models';
import { ANNOTATIONS_TYPE } from '../ExportCompound.constant';
import { AnnotationsType } from './Annotations.types';

type CheckboxElement = { id: string; label: string };

type CheckboxElements = CheckboxElement[];

type GetAnnotationsCheckboxElements = {
  type: AnnotationsType;
  statistics: Statistics | undefined;
  miriamTypes: MiriamType[];
};

type AnnotationCount = { type: string; count: number };

const sortByCount = (a: AnnotationCount, b: AnnotationCount): number => {
  return a.count > b.count ? -ONE : ONE;
};

const findEntryByName = (name: string, miriamTypes: MiriamType[]): MiriamType | undefined =>
  miriamTypes.find(miriamType => miriamType.name === name);

const mapToCheckboxElement = (
  annotation: AnnotationCount,
  miriamTypes: MiriamType[],
): CheckboxElement | undefined => {
  const entry = findEntryByName(annotation.type, miriamTypes);
  if (!entry) return undefined;

  return { id: entry.name, label: entry.commonName };
};

export const getAnnotationsCheckboxElements = ({
  type,
  statistics,
  miriamTypes,
}: GetAnnotationsCheckboxElements): CheckboxElements => {
  if (!statistics) return [];

  const annotations =
    type === ANNOTATIONS_TYPE.ELEMENTS
      ? statistics.elementAnnotations
      : statistics.reactionAnnotations;

  return annotations
    .filter(annotation => annotation.count > ZERO)
    .sort(sortByCount)
    .map(annotation => mapToCheckboxElement(annotation, miriamTypes))
    .filter((checkboxElement): checkboxElement is CheckboxElement => checkboxElement !== undefined);
};
